module.exports = __webpack_public_path__ + "static/front/img/banner-1.0cc36afa.jpg";